var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollabAiLogoBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 262.7 90.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.97,38.21h0s-6.19-3.23-6.19-3.23l-6.19-3.23-6.19-3.23-6.19-3.23-6.19-3.23v49.55l6.19,3.23,6.19,3.23v-12.39l6.19,3.23,6.19,3.23v12.39l6.19,3.23,6.19,3.23v-49.56l-6.19-3.23ZM24.78,53.57v6.19l-6.19-3.23-6.19-3.23v-12.39l6.19,3.23,6.19,3.23v6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.26,25.3l-6.19,3.23-6.19,3.23-6.19,3.23-6.19,3.23h0s-6.19,3.23-6.19,3.23v12.39l6.19-3.23,6.19-3.23v24.79l-6.19,3.23-6.19,3.23v12.38l6.19-3.23,6.19-3.23,6.19-3.23,6.19-3.23,6.19-3.23,6.19-3.23v-12.39l-6.19,3.23-6.19,3.23v-24.79l6.19-3.23,6.19-3.23v-12.38l-6.19,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.71,16.13l-6.19-3.23-6.2,3.23-6.19,3.23-12.39,6.45-6.2-3.23-6.2-3.23,6.19-3.22,6.19-3.23,6.19-3.23,6.2-3.23-6.2-3.23-6.19-3.23h0l-6.19,3.23h0l-6.19,3.23h0l-6.19,3.22-6.19,3.23-6.19,3.23h0l-6.19,3.23,6.19,3.23,6.19,3.23,6.2,3.23,6.2,3.23,6.19,3.23,6.19,3.22,6.19-3.23,6.19-3.23,6.19-3.23,6.19-3.23,6.19-3.23,6.2-3.23-6.18-3.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M95.86,30.63h15.34v5.92h-8.49v20.95h8.49v5.92h-15.34V30.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5,37.59h19.21v25.84h-19.21v-25.84ZM128.07,57.57v-14.13h-5.92v14.13h5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.15,27.57h6.65v35.85h-6.65V27.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61,27.57h6.64v35.85h-6.64V27.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.75,63.42h-18.88v-16.22h12.24v-3.76h-12.17v-5.85h18.81v25.84ZM174.11,57.57v-5.94h-5.81v5.94h5.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.83,37.59h12.59v25.84h-19.23V27.57h6.64v10.01ZM197.75,57.57v-14.13h-5.92v14.13h5.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.58,30.63h20.88v32.79h-6.82v-10.69h-7.22v10.69h-6.84V30.63ZM223.43,36.55v10.28h7.22v-10.28h-7.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.7 36.55 262.7 30.63 256.51 30.63 253.09 30.63 249.67 30.63 243.47 30.63 243.47 36.55 249.67 36.55 249.67 57.5 243.47 57.5 243.47 63.42 249.67 63.42 253.09 63.42 256.51 63.42 262.7 63.42 262.7 57.5 256.51 57.5 256.51 36.55 262.7 36.55"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabAiLogoBlack);
export default __webpack_public_path__ + "static/media/collab_ai_logo_black.70e5e81b4cfc66c509abd26599cbfbed.svg";
export { ForwardRef as ReactComponent };